import * as Yup from "yup"

export const tpmrFormSchema = Yup.object().shape({
    batch_id: Yup.string().nullable(),
    enrolment_id: Yup.string().required(),
    student_id: Yup.string().required(),
    practical_type: Yup.string().required("Practical type is required"),
    date: Yup.string().required("Training date is required"),
    course_options: Yup.object().test(
        'at-least-one',
        'At least one course grade must be selected',
        (value) => value && Object.values(value).some(grade => grade !== '')
    ),
    remarks: Yup.string().nullable()
})